import * as Models from '../../../../models';
import { ResourcesList } from '../../../../models/response';
import { ChallengesParams, getChallenges } from '../../../exam-service/functions';
import { getOppositions } from '../../../opposition-service';
import { TestsEndpoints } from '../../../../endpoint';
import { buildChallengeForListMapper } from '../../../../mappers/api2_0';
import { getAcademies, getStudents, getUserAvatars } from './_utils';

interface GetChallengesForListParams {
  filters: ChallengesParams;
}

/**
 * Return challenges mapped to be used in challenge list
 */
export const getChallengesForList = async ({
  filters,
}: GetChallengesForListParams): Promise<ResourcesList<Models.ChallengeForList>> => {
  const challenges = await getChallenges(filters);

  if (!challenges.resources.length) {
    return {
      resources: [],
      paginator: challenges.paginator,
    };
  }

  const challengeTokens: Models.ChallengeToken[] = [];
  const oppositionIds: Models.OppositionId[] = [];
  const academiesCodes: Models.ChallengeAcademyType[] = [];
  const creatorIds: number[] = [];

  challenges.resources.forEach(challenge => {
    challenge.token && challengeTokens.push(challenge.token);
    oppositionIds.push(challenge.oppositionId);
    if (challenge.creator.type === Models.ChallengeCreatorType.Academy) {
      if (challenge.creator.academyCode !== null) {
        academiesCodes.push(challenge.creator.academyCode);
      } else {
        //TODO Log a warning, data is inconsistent as academy code is null
      }
    } else {
      creatorIds.push(challenge.creator.id);
    }
  });

  const [oppositions, challengeParticipationInfo, academies, creatorProfiles, avatars] = await Promise.all([
    getOppositions({ ids: oppositionIds, pageSize: oppositionIds.length }),
    TestsEndpoints.getParticipatedInChallenge({ filters: { tokens: challengeTokens } }),
    getAcademies(academiesCodes),
    getStudents(creatorIds),
    getUserAvatars(creatorIds),
  ]);

  const mapChallengeForList = buildChallengeForListMapper({
    academies,
    creatorProfiles,
    avatars,
    participationInfo: challengeParticipationInfo.resources,
    oppositions: oppositions.resources,
  });

  const challengesForList: Models.ChallengeForList[] = challenges.resources.map(mapChallengeForList);

  return { resources: challengesForList, paginator: challenges.paginator };
};
